import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { BodySmall } from '#/components/Text/BodySmall';
import { colors } from '#/theme/theme';

import {
  CmsTileModalLeftContentHolder,
  CmsTileModalLeftContentImageHolder,
} from './CmsTileModalLeftContent.styled';

type Props = {
  imageData: ApiFilestackImageData;
  caption: string | undefined;
};

export function CmsTileModalLeftContent({ imageData, caption }: Props) {
  return (
    <CmsTileModalLeftContentHolder>
      <CmsTileModalLeftContentImageHolder>
        <FilestackImage
          data={imageData}
          objectFit="cover"
          expandSize
          width={1200}
          height={1200}
        />
      </CmsTileModalLeftContentImageHolder>

      {caption && (
        <div style={{ marginTop: 8 }}>
          <BodySmall color={colors.lightContentGrey} tag="figcaption">
            {caption}
          </BodySmall>
        </div>
      )}
    </CmsTileModalLeftContentHolder>
  );
}
